import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungDessau() {
  return (
    <CityPageTemplate
      city="Dessau"
      slug="dessau"
      intro="Dessau-Roßlau als Bauhaus-Stadt – wir gestalten auch Deine Finanzen nach modernen Grundsätzen."
      description="Unabhängige & digitale Finanzberatung für Dessau: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
